import window from 'window-or-global';
import { CONTEXT_PATH } from '@confluence-classic/confluence-urls';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

const ShortcutLinks = function () {
	let shortcutLinkConfigurations = [];

	const loadShortcutLinkConfiguration = function () {
		$.ajax({
			url: `${CONTEXT_PATH}/rest/autoconvert/latest/shortcutlinkconfigurations`,
			type: 'GET',
			dataType: 'json',
			success(data) {
				shortcutLinkConfigurations = data['configurations'];
				for (let i = 0; i < shortcutLinkConfigurations.length; i++) {
					const config = shortcutLinkConfigurations[i];
					try {
						config.regex = new RegExp(translateToRegex(config.expandedValue, config.defaultAlias));
					} catch (e) {
						console.log(`Failed to generated regex for ${config}`);
					}
				}
			},
			error(response) {
				console.log(`Failed to load shortcut link configurations ${response.statusText}`);
			},
		});
	};

	const translateToRegex = function (expandedValue) {
		if (expandedValue.indexOf('%s') >= 0) {
			return expandedValue.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&').replace('%s', '(.*)');
		}
		return `${expandedValue.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}(.*)`;
	};

	const pasteHandler = function (uri, node, done) {
		if (uri.source !== node.text()) {
			done();
			return;
		}
		for (let i = 0; i < shortcutLinkConfigurations.length; i++) {
			const shortcutLinkConfig = shortcutLinkConfigurations[i];
			const matches = uri.source.match(shortcutLinkConfig.regex);
			if (matches) {
				const q = matches[1];
				if (shortcutLinkConfig.defaultAlias) {
					const newText = shortcutLinkConfig.defaultAlias.replace(/%s/, q);
					done($(node).text(newText));
					return;
				}
				done($(node).text(q));
				return;
			}
		}
		done();
	};

	window.tinymce.plugins.Autoconvert.autoConvert.addHandler(pasteHandler);
	setTimeout(() => {
		loadShortcutLinkConfiguration();
	}, 0);
};

export default function () {
	bind('init.rte', ShortcutLinks);
}
